import { useAuthPages } from "../i18n/authPagesPresentation";
import { useEffect, useState } from "react";
import { Card } from "../components/ui/Card";
import { ThemeSwitcher } from "../components/theme/ThemeSwitcher";

type MaintenancePayload = {
  enabled: boolean;
  message: string | null;
  enabledAt?: string | null;
};

export const MaintenancePage = () => {
  const t = useAuthPages();
  const [maintenance, setMaintenance] = useState<MaintenancePayload | null>(null);

  useEffect(() => {
    let active = true;
    fetch("/api/system/maintenance", { headers: { Accept: "application/json" } })
      .then(async (res) => {
        const data = await res.json().catch(() => null);
        if (!active) return;
        if (data?.maintenance) {
          setMaintenance(data.maintenance);
          return;
        }
        setMaintenance({ enabled: true, message: null });
      })
      .catch(() => {
        if (active) {
          setMaintenance({ enabled: true, message: null });
        }
      });
    return () => {
      active = false;
    };
  }, []);

  const message = maintenance?.message ?? t($ => $.maintenanceDefault);

  return (
    <div className="surface-grid flex min-h-screen items-center justify-center px-6 py-12">
      <div className="w-full max-w-md">
        <div className="mb-8 text-center">
          <div className="mx-auto mb-4 flex h-12 w-12 items-center justify-center rounded-lg bg-amber-500 text-white text-lg font-semibold">
            QB
          </div>
          <h1 className="text-3xl font-semibold min-w-0 break-words hyphens-auto">{t($ => $.maintenanceTitle)}</h1>
          <p className="text-sm text-muted-foreground">{t($ => $.maintenanceSubtitle)}</p>
        </div>

        <Card className="glass-card">
          <div className="mb-5 flex items-center justify-between">
            <div>
              <h2 className="text-lg font-semibold">{t($ => $.maintenanceHeading)}</h2>
              <p className="text-sm text-muted-foreground">{t($ => $.maintenanceThanks)}</p>
            </div>
            <ThemeSwitcher compact />
          </div>

          <div className="rounded-lg border border-border/60 bg-muted/60 px-4 py-3 text-sm text-foreground">
            {message}
          </div>
        </Card>
      </div>
    </div>
  );
};
